export default __webpack_public_path__ + "static/media/serach-Icon.9080dcfa.svg";